export const getUserInitials = user => {
    let name = user.name;
    if (name.includes('@')) {
        name = name.split('@')[0];
    }
    if (name.includes(' ')) {
        const splitName = name.split(' ');
        return `${splitName[0][0]}${splitName[splitName.length - 1][0]}`.toUpperCase();
    }
    if (name.includes('.')) {
        const splitName = name.split('.');
        return `${splitName[0][0]}${splitName[splitName.length - 1][0]}`.toUpperCase();
    }
    return name.charAt(0).toUpperCase();
};
const colors = [
    '#D32F2F',
    '#C2185B',
    '#7B1FA2',
    '#512DA6',
    '#393F9F',
    '#1976D2',
    '#00795B',
];
export const getBackgroundColor = stringInput => {
    const stringUniqueHash = [...stringInput].reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);
    return colors[stringUniqueHash % 7];
};
